import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, MANUFACTURE } = authRoles

const Suppliers = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const suppliersModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/suppliers',
    name: 'suppliers',
    component: Suppliers,
    meta: {
      title: 'Proveedores',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
